
const contents = "query StorylineSettingsClients {\n  settings {\n    stories {\n      viewerCanAccessStories\n    }\n    storyline {\n      viewerCanAccessStoryline\n      viewerCanPostStorylineAnnouncement\n      canUseDelegateTeamsOnStoryline\n      viewerCanPromoteConversationInStoryline\n    }\n  }\n}\n";
const sha256Hash = "e15c17283fefd85d0c4cef98e259f4f9440e0f5736b6eddf97ad812b1fdd7fbb";
export default { contents: contents, sha256Hash: sha256Hash };
